export default "__VITE_ASSET__CqK2TdNo__"